export default __webpack_public_path__ + "static/media/login-bg.cb4a57a4.jpeg";